import BunkeyAPI from '../api/BunkeyAPI'
import {
  ASSET_CONFIRM_GET_DATA,
  ASSET_CONFIRM_GET_DATA_SUCCESS,
  ASSET_CONFIRM_GET_DATA_FAILURE,
  ASSET_CONFIRM_EDIT,
  ASSET_CONFIRM_EDIT_SUCCESS,
  ASSET_CONFIRM_EDIT_FAILURE,
  ASSET_CONFIRM_DELETE,
  ASSET_CONFIRM_DELETE_SUCCESS,
  ASSET_CONFIRM_DELETE_FAILURE,
  ASSET_CONFIRM_EXISTS_SUCCESS,
  ASSET_CONFIRM_EXISTS_FAILURE,
  ASSET_CONFIRM_ADD_TAGS,
  ASSET_CONFIRM_CHANGE_NAME,
  ASSET_CONFIRM_CHANGE_COPYRIGHT,
  ASSET_CONFIRM_MOVE_FOLDER,
  ASSET_CONFIRM_MOVE_FOLDER_SUCCESS,
  ASSET_CONFIRM_MOVE_FOLDER_FAILURE,
  ASSET_BY_CONFIRM,
} from '../constants/assets-confirm-types'
import fileExtension from 'file-extension'
import store from '../store'
import axios from 'axios'
import { sendNotification, ENDPOINT, permissionsDefault, validateImageSpecialExtensions } from '../utils/index'

export const getConfirmAssets = (workclient, page, iduser) => {

  const confirmAssetsBy = store.getState().assetsConfirm.confirmAssetsBy
  let userId = confirmAssetsBy === 'mine' ? `&userConfirm=${iduser}` : ''

  return dispatch => {
    dispatch({ type: ASSET_CONFIRM_GET_DATA })
    BunkeyAPI({
      url: `/clients/${workclient}/objects?status=pending&page=${page}&limit=10${userId}`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: ASSET_CONFIRM_GET_DATA_SUCCESS,
        payload: {
          headers: resp.headers,
          page,
          data: resp.data
            .filter(r => ['document', 'image', 'video'].includes(r.type))
            .map(r => {
              return {
                _id: r._id,
                type: validateImageSpecialExtensions(r.originalURL) ? 'document' : r.type,
                name: r.name,
                extension: fileExtension(r.originalURL),
                lowQualityURL: r.lowQualityURL,
                mediaQualityURL: r.mediaQualityURL,
                originalURL: r.originalURL,
                metadata: r.metadata,
                parents: r.parents,
                createdAt: r.createdAt,
                isUpdated: false,
                group: r.group,
                objectGroups: r.objectGroup,
                matrix: permissionsDefault().map(def => {
                  const exists = r.group.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
                  return {
                    action: def.action,
                    enabled: exists ? true : false
                  }
                }),
                username: r.username,
                uuid: r.uuid,
              }
            }),
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_CONFIRM_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}

export const existsConfirmAssets = workclient => {
  return dispatch => {
    try {
      const { accessToken } = store.getState().authUser.token
      axios.get(`${ENDPOINT}clients/${workclient}/objects?status=pending&page=1&limit=1`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      }).then(resp => {
        dispatch({
          type: ASSET_CONFIRM_EXISTS_SUCCESS,
          payload: resp.data.length > 0
        })
      }).catch(err => {
        dispatch({ type: ASSET_CONFIRM_EXISTS_FAILURE })
      })
    } catch (error) {
      const { pidValue } = store.getState().client
      clearInterval(pidValue)
      dispatch({ type: ASSET_CONFIRM_EXISTS_FAILURE })
    }
  }
}

export const addTagsConfirmAsset = (asset, newTags) => {
  return dispatch => {
    dispatch({
      type: ASSET_CONFIRM_ADD_TAGS,
      payload: {
        asset: asset,
        newTag: newTags
      }
    })
  }
}

export const changeNameConfirmAsset = (name, asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_CONFIRM_CHANGE_NAME,
      payload: {
        asset: asset,
        name: name
      }
    })
  }
}

export const changeCopyRightConfirmAsset = (copyright, asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_CONFIRM_CHANGE_COPYRIGHT,
      payload: {
        asset: asset,
        copyright: copyright
      }
    })
  }
}

export const confirmAsset = (workclient, asset, page = 1, intl, idUser) => {

  return dispatch => {
    dispatch({ type: ASSET_CONFIRM_EDIT })
    // Los campos de derechos van por su propio endpoint (notación de punto):
    // mandarlos junto al PUT genérico de abajo pisaría el resto del metadata
    // del asset (audiovisualTags, licenseFile, copyRight, rightsAssignedBy).
    //
    // Y tienen que terminar ANTES de marcar el asset como confirmado. En
    // cuentas sin el módulo (DES-216) quien subió el archivo sólo puede
    // asignar derechos mientras sigue pendiente; si los dos PUT corren en
    // paralelo y gana setReadyStatus, el backend rechaza las fechas del
    // operador y se pierden sin aviso.
    const rightsSaved = asset.metadata.rightsStatus
      ? BunkeyAPI({
          url: `/clients/${workclient}/rights/assets/${asset._id}`,
          method: 'PUT',
          data: {
            userid: idUser,
            rightsStatus: asset.metadata.rightsStatus,
            createdDate: asset.metadata.createdDate,
            dueDate: asset.metadata.dueDate
          }
        }).catch(err => {
          console.log('error confirmAsset rights: ', err)
        })
      : Promise.resolve()
    rightsSaved.then(() => BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags
        }
      }
    })).then(resp => {
      BunkeyAPI({
        url: `/clients/${workclient}/objects/${asset._id}`,
        method: 'PUT',
        data: {
          'action': 'setReadyStatus'
        }
      }).then(resp => {
        dispatch({
          type: ASSET_CONFIRM_EDIT_SUCCESS,
          payload: {
            id: asset._id,
            headers: resp.headers
          }
        })
        dispatch(getConfirmAssets(workclient, page, idUser))
        sendNotification('success', intl, `${intl.formatMessage({ id: "the_asset" })} ${asset.name} ${intl.formatMessage({ id: "has_been_confirm" })}`)
      }).catch(err => {
        dispatch({
          type: ASSET_CONFIRM_EDIT_FAILURE,
          payload: err
        })
      })
    }).catch(err => {
      dispatch({
        type: ASSET_CONFIRM_EDIT_FAILURE,
        payload: { _id: asset._id, err: err }
      })
    })
  }
}

export const deleteAsset = (workclient, asset, page = 1, intl, idUser) => {
  return dispatch => {
    dispatch({ type: ASSET_CONFIRM_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'DELETE',
    }).then(resp => {
      dispatch({
        type: ASSET_CONFIRM_DELETE_SUCCESS,
        payload: {
          workclient,
          id: asset._id
        }
      })
      dispatch(getConfirmAssets(workclient, page, idUser))
      sendNotification('success', intl, `${intl.formatMessage({ id: "the_asset" })} ${asset.name} ${intl.formatMessage({ id: "has_been_deleted" })}`)
    }).catch(err => {
      dispatch({
        type: ASSET_CONFIRM_DELETE_FAILURE,
        payload: {
          workclient,
          id: asset._id,
          error: err
        }
      })
    })
  }
}

export const moveFolderConfirmAsset = (workclient, item, folderselect, page, intl) => {
  return dispatch => {
    dispatch({ type: ASSET_CONFIRM_MOVE_FOLDER })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${item._id}`,
      method: 'PUT',
      data: {
        action: 'move',
        folder: folderselect,
      }
    }).then(resp => {
      dispatch({ type: ASSET_CONFIRM_MOVE_FOLDER_SUCCESS })
    }).catch(err => {
      dispatch({
        type: ASSET_CONFIRM_MOVE_FOLDER_FAILURE,
        payload: {
          err,
          status: 'failure'
        }
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'the_asset' })} ${item.name} ${intl.formatMessage({ id: "could_not_move" })}`)
    })
  }
}

export const confirmBy = (confirmBy) => {
  return dispatch => {
    dispatch({ type: ASSET_BY_CONFIRM, payload: confirmBy })
  }
}

